/* Spence product card behaviour */
(function () {
  if (customElements.get('spence-card')) return;
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

  customElements.define('spence-card', class extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-spc-data]');
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { this.data = { colours: [], currentIndex: 0 }; }
      this.colourIdx = this.data.currentIndex || 0;
      this.selectedSize = null;
      this.pendingAdd = null;
      this.links = [].slice.call(this.querySelectorAll('[data-spc-link]'));
      this.mediaLink = this.querySelector('[data-spc-media-link]');
      this.track = this.querySelector('[data-spc-track]');
      this.dots = this.querySelector('[data-spc-dots]');
      this.bar = this.querySelector('[data-spc-bar]');
      this.sizesEl = this.querySelector('[data-spc-sizes]');
      this.addBtn = this.querySelector('[data-spc-add]');
      this.idInput = this.querySelector('[data-spc-id]');
      this.priceWrap = this.querySelector('[data-spc-price-wrap]');
      this.addedEl = this.querySelector('[data-spc-added]');

      var self = this;
      this.addEventListener('mouseleave', function () {
        if (!HOVER.matches) return;
        if (self.selectedSize === null) self.closeBar();
      });

      if (this.track) {
        var raf = null;
        this.track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
            self.setDots(i);
          });
        }, { passive: true });
      }

      this.initDrag();
      this.bindSwatches();
      this.bindCells();
      this.bindBar();
      this.updateBarH();

      this._onAdded = function () { self.onAdded(); };
      this._onAddError = function () { self.onAddError(); };
      document.addEventListener('theme:product:added', this._onAdded);
      document.addEventListener('theme:product:add-error', this._onAddError);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:added', this._onAdded);
      document.removeEventListener('theme:product:add-error', this._onAddError);
    }

    colour() { return this.data.colours[this.colourIdx] || {}; }
    imageCount() {
      var imgs = this.colour().images;
      if (imgs && imgs.length) return imgs.length;
      return this.track ? this.track.children.length : 0;
    }
    priceText() {
      var c = this.colour();
      if (c.price) return c.price;
      var p = this.querySelector('[data-spc-price]');
      return p ? p.textContent : '';
    }

    /* Desktop mouse drag-to-swipe; navigation suppressed after a real drag */
    initDrag() {
      if (!this.track) return;
      var self = this;
      var t = this.track;
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startLeft = 0;

      t.addEventListener('dragstart', function (e) { e.preventDefault(); });

      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        dragging = true;
        moved = false;
        startX = e.clientX;
        startLeft = t.scrollLeft;
        t.style.scrollSnapType = 'none';
        if (self.mediaLink) self.mediaLink.classList.add('is-dragging');
      });

      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        t.scrollLeft = startLeft - dx;
      });

      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        if (self.mediaLink) self.mediaLink.classList.remove('is-dragging');
        var w = t.clientWidth || 1;
        var idx = Math.max(0, Math.min(self.imageCount() - 1, Math.round(t.scrollLeft / w)));
        t.style.scrollSnapType = '';
        t.scrollTo({ left: idx * w, behavior: 'smooth' });
        if (moved) {
          self._suppressClick = true;
          setTimeout(function () { self._suppressClick = false; }, 80);
        }
      });

      if (this.mediaLink) {
        this.mediaLink.addEventListener('click', function (e) {
          if (self._suppressClick) { e.preventDefault(); e.stopPropagation(); }
        });
      }
    }

    /* Max 3 dots: first image -> dot 1, last image -> dot 3, anything between -> dot 2 */
    setDots(i) {
      if (!this.dots) return;
      var dots = [].slice.call(this.dots.children);
      if (!dots.length) return;
      var total = this.imageCount();
      var active;
      if (total <= dots.length) {
        active = Math.min(i, dots.length - 1);
      } else if (i <= 0) {
        active = 0;
      } else if (i >= total - 1) {
        active = dots.length - 1;
      } else {
        active = 1;
      }
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === active); });
    }

    updateBarH() { this.style.setProperty('--spc-bar-h', (this.selectedSize ? 81 : 41) + 'px'); }

    closeBar() {
      this.selectedSize = null;
      this.classList.remove('has-size');
      var cells = this.querySelectorAll('[data-spc-cell]');
      [].slice.call(cells).forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
      this.updateBarH();
    }

    bindSwatches() {
      var self = this;
      [].slice.call(this.querySelectorAll('[data-spc-swatch]')).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.setColour(parseInt(btn.getAttribute('data-spc-swatch'), 10));
        });
      });
    }

    setColour(idx) {
      if (idx === this.colourIdx || !this.data.colours[idx]) return;
      this.colourIdx = idx;
      var c = this.colour();
      [].slice.call(this.querySelectorAll('[data-spc-swatch]')).forEach(function (b) {
        b.classList.toggle('is-selected', parseInt(b.getAttribute('data-spc-swatch'), 10) === idx);
      });
      this.links.forEach(function (a) { a.href = c.url; });
      if (this.priceWrap) {
        this.priceWrap.innerHTML = '<span data-spc-price>' + c.price + '</span>' + (c.compareAt ? '<s class="spc-card__compare">' + c.compareAt + '</s>' : '');
      }
      if (this.track) {
        this.track.innerHTML = (c.images || []).map(function (src) {
          return '<div class="spc-card__slide"><img src="' + src + '" alt="" loading="lazy"></div>';
        }).join('');
        this.track.scrollLeft = 0;
      }
      if (this.dots) {
        var count = (c.images || []).length;
        var dotCount = Math.min(count, 3);
        var html = '';
        for (var i = 0; i < dotCount; i++) html += '<span' + (i === 0 ? ' class="is-active"' : '') + '></span>';
        this.dots.innerHTML = html;
        this.dots.style.display = count > 1 ? '' : 'none';
      }
      this.setDots(0);
      this.renderSizes();
      this.closeBar();
      this.clearAdded();
    }

    renderSizes() {
      if (!this.sizesEl) return;
      var c = this.colour();
      var sizes = c.sizes || [];
      var cells = sizes;
      var plus = false;
      if (sizes.length > 6) { cells = sizes.slice(0, 5); plus = true; }
      this.sizesEl.innerHTML = cells.map(function (s) {
        var dis = !s.a;
        return '<button type="button" class="spc-bar__cell' + (dis ? ' is-soldout' : '') + '" role="radio" aria-checked="false"' + (dis ? ' aria-disabled="true" tabindex="-1"' : '') + ' data-spc-cell data-size="' + s.l + '" data-variant="' + s.id + '">' + s.l + '</button>';
      }).join('') + (plus ? '<a class="spc-bar__cell" href="' + c.url + '" data-spc-plus aria-label="More sizes">+</a>' : '');
      this.bindCells();
    }

    bindCells() {
      var self = this;
      [].slice.call(this.querySelectorAll('[data-spc-cell]')).forEach(function (cell) {
        if (cell._spcBound) return;
        cell._spcBound = true;
        cell.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (cell.classList.contains('is-soldout')) return;
          var was = cell.classList.contains('is-selected');
          [].slice.call(self.querySelectorAll('[data-spc-cell]')).forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-checked', 'false');
          });
          self.clearAdded();
          if (was) {
            self.selectedSize = null;
            self.classList.remove('has-size');
          } else {
            cell.classList.add('is-selected');
            cell.setAttribute('aria-checked', 'true');
            self.selectedSize = { label: cell.getAttribute('data-size'), id: cell.getAttribute('data-variant') };
            self.classList.add('has-size');
            if (self.addBtn) {
              self.addBtn.disabled = false;
              self.addBtn.textContent = 'Add ' + self.selectedSize.label + ' to bag · ' + self.priceText();
            }
            if (self.idInput) self.idInput.value = self.selectedSize.id;
          }
          self.updateBarH();
        });
      });
      var plus = this.querySelector('[data-spc-plus]');
      if (plus && !plus._spcBound) {
        plus._spcBound = true;
        plus.addEventListener('click', function (e) { e.stopPropagation(); });
      }
    }

    bindBar() {
      var self = this;
      if (this.bar) this.bar.addEventListener('click', function (e) { e.stopPropagation(); });
      if (!this.addBtn) return;
      this.addBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!self.selectedSize) { e.preventDefault(); return; }
        var drawer = document.querySelector('cart-drawer');
        var cartType = window.theme && window.theme.settings && window.theme.settings.cartType;
        if (drawer && cartType === 'drawer') {
          e.preventDefault();
          self.pendingAdd = self.selectedSize;
          document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: self.addBtn }, bubbles: false }));
          self.addBtn.disabled = true;
          clearTimeout(self._t);
          self._t = setTimeout(function () { if (self.pendingAdd) self.onAdded(); }, 4000);
        }
        /* else: native form submit posts to /cart/add */
      });
    }

    onAdded() {
      if (!this.pendingAdd) return;
      var s = this.pendingAdd;
      this.pendingAdd = null;
      clearTimeout(this._t);
      if (this.addBtn) this.addBtn.disabled = false;
      if (this.addedEl) this.addedEl.textContent = 'Added ' + s.label + ' to bag ✓';
      this.closeBar();
    }

    onAddError() {
      if (!this.pendingAdd) return;
      this.pendingAdd = null;
      clearTimeout(this._t);
      if (this.addBtn) {
        this.addBtn.disabled = false;
        this.addBtn.textContent = "Couldn't add — try again";
      }
    }

    clearAdded() { if (this.addedEl) this.addedEl.textContent = ''; }
  });
})();
